/*
 * Copyright © 2025. Legalbird eine Marke der Legalbird GmbH
 */

import React from "react";
import TextContainer from "../../../Container/TextContainer";
import CostsSecureIcon from "../../../../assets/icons/generic/IconCostSecurity";
import ContainerFullWidth from "../../../Container/ContainerFullWidth";
import Typography from "@mui/material/Typography";
import noWinNoFeeSectionStyle from "./noWinNoFeeSectionStyle";
import { Box } from "@mui/material";

type NoWinNoFeeSectionProps = {
  sectionPadding?: boolean;
};

const NoWinNoFeeSection = ({ sectionPadding = false }: NoWinNoFeeSectionProps) => {
  return (
    <ContainerFullWidth sx={noWinNoFeeSectionStyle.noWinNoFeeSection} sectionPadding={sectionPadding}>
      <Box sx={noWinNoFeeSectionStyle.scrollToAnchor} id="kein-kostenrisiko" />
      <Typography component={"h2"} variant={"h3"}>Fordern Sie Ihr Recht ein - komplett ohne Kostenrisiko!</Typography>
      <CostsSecureIcon sx={noWinNoFeeSectionStyle.costsSecureIcon} />
      <TextContainer>
        <Typography component={"h3"} variant={"h6"} sx={noWinNoFeeSectionStyle.h3}>
          Unser Versprechen an Sie: Kostenlose Prüfung
        </Typography>
        <Typography variant={"body2"}>Wir prüfen Ihre Kündigung kostenlos und sorgen dafür, dass Sie sich auch danach über die Kosten keine Sorgen machen müssen.</Typography>
        <Typography component={"h3"} variant={"h6"} sx={noWinNoFeeSectionStyle.h3}>
          Auch nach der Prüfung: Ohne Risiko gegen Kündigung vorgehen
        </Typography>
        <Typography component={"h4"} variant={"h5"} sx={noWinNoFeeSectionStyle.subHeadline}>
          Ohne Rechtsschutzversicherung
        </Typography>
        <Typography variant={"body2"}>
          Sie möchten gegen die Kündigung vorgehen, machen sich aber Sorgen wegen der Kosten? Nicht bei uns! Unser Prozesskostenfinanzierer übernimmt vorab alle
          Anwalts- und Gerichtskosten für Sie! Sie bezahlen dann am Ende nur bei Erfolg eine Erfolgsprovision.
        </Typography>
        <Typography component={"h4"} variant={"h5"} sx={noWinNoFeeSectionStyle.subHeadline}>
          Mit Rechtsschutzversicherung
        </Typography>
        <Typography variant={"body2"}>
          Sie haben eine Rechtsschutzversicherung für Arbeitsrecht? Dann fallen für Sie keine Kosten an! Legalbird übernimmt sogar den Selbstbehalt für Sie!
        </Typography>
      </TextContainer>
    </ContainerFullWidth>
  );
};

export default NoWinNoFeeSection;
